import { useWorkspaceRightPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelStore';

/** Whether the workspace right panel is editing a canvas (committed or draft). Store-only — safe on public pages. */
export const useIsEditingCanvasInWorkspacePanel = () => {
  const selectedCanvasId = useWorkspaceRightPanelStore((state) => state.selectedCanvasId);
  const isDraft = useWorkspaceRightPanelStore((state) => !!state.draftCanvas);

  return !!(selectedCanvasId || isDraft);
};
